/**
 * Where the convention guide lives, as a signed-out door can know it.
 *
 * "Return to the convention guide" was written as `/`. On a host serving one surface that
 * is that surface's own root, so on staff.wvcea.app the link offering to leave staff
 * sign-in reloaded staff sign-in — the reader got the page they were trying to get away
 * from, with nothing to say why. A door with nobody signed in holds no association record
 * to work the address out from, so the server sends it along with the sign-in
 * configuration that page already asks for.
 *
 * Null means there is no separate public host to go to, and the link is not drawn at all
 * rather than drawn as somewhere it cannot reach.
 */
let cached: string | null | undefined;
let inFlight: Promise<string | null> | undefined;

export async function loadGuideOrigin(): Promise<string | null> {
  if (cached !== undefined) return cached;
  inFlight ??= fetch("/api/sign-in-config", { credentials: "same-origin" })
    .then(async (response) => {
      if (!response.ok) return null;
      const config = (await response.json()) as { guideOrigin?: string | null };
      return config.guideOrigin ?? null;
    })
    .catch(() => null)
    .then((origin) => {
      cached = origin;
      return origin;
    });
  return inFlight;
}
